module.exports = __webpack_public_path__ + "img/4.03588fdd.png";